export const typeOfRemoteAccessDialog = 'typeOfRemoteAccessDialog';
export const typeOfRemoteAccessActivationSuccessDialog = 'typeOfRemoteAccessActivationSuccessDialog';
export const typeOfRemoteAccessActivationErrorDialog = 'typeOfRemoteAccessActivationErrorDialog';
export const typeOfRemoteAccessLoginPromptDialog = 'typeOfRemoteAccessLoginPromptDialog';

export const STEPS = {
  INITIAL: 'INITIAL',
  CHOICE: 'CHOICE',
  ACTIVATION: 'ACTIVATION',
};
// Single source of truth for each dialog's visible heading and its accessible name — the two must
// not be able to drift apart.
export const remoteAccessDialogTitles = {
  CHOICE: 'Remote access',
  ACTIVATION: 'Remote access activation',
};
export const emailInvalidMessage = 'Please enter valid email address';
export const remoteAccessDialogReducerKey = 'remoteAccessDialogReducer';
export const remoteAccessDialogSetStepReducerType = 'remoteAccessDialogSetStepReducerType';
export const remoteAccessDialogSetDepartmentsReducerType = 'remoteAccessDialogSetDepartmentsReducerType';
export const remoteAccessDialogSetIsLoadingReducerType = 'remoteAccessDialogSetIsLoadingReducerType';

export const errorTypeEnforcedNoReg = 'ENFORCED_NO_REG';
